import axios from "axios";
import { UUID } from "../utils/uuid.js";
import { PaymentNotification } from "./../models/Notification";

import getErrorDetails from "./helpers/getErrorDetails.js";

export async function getOutstandingNotifications(
  clientId: UUID,
  options: any
): Promise<any> {
  try {
    const response = await axios({
      ...options,
      method: "GET",
      url: `/clients/${clientId}/notifications/outstanding`,
    });
    const { data = {} } = response;

    return { ...data, clientId };
  } catch (error) {
    throw getErrorDetails(error);
  }
}

export async function postNotificationsTest(
  clientId: UUID,
  options: any
): Promise<any> {
  try {
    const response = await axios({
      ...options,
      method: "POST",
      url: `/clients/${clientId}/notifications/test`,
    });
    const { data = {} } = response;
    return data;
  } catch (error) {
    throw getErrorDetails(error);
  }
}

export async function getFailedNotifications(
  clientId: UUID,
  options: any
): Promise<PaymentNotification[]> {
  try {
    const response = await axios({
      ...options,
      method: "GET",
      url: `/clients/${clientId}/notifications/failed`,
    });
    const { data = {} } = response;
    return { ...data, clientId };
  } catch (error) {
    throw getErrorDetails(error);
  }
}

export async function getFailingNotifications(options: any): Promise<any> {
  try {
    const response = await axios({
      ...options,
      method: "GET",
      url: `/notifications/failures`,
    });
    const { data = {} } = response;
    return data;
  } catch (error) {
    throw getErrorDetails(error);
  }
}

export async function getNotificationsSettings(
  clientId: UUID,
  options: any
): Promise<any> {
  try {
    const response = await axios({
      ...options,
      method: "GET",
      url: `/clients/${clientId}/notifications/settings`,
    });
    const { data = {} } = response;
    return { ...data, clientId };
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return {};
    }
    throw getErrorDetails(error);
  }
}

export async function postNotificationsSettings(
  clientId: UUID,
  settings: any,
  options: any
): Promise<any> {
  try {
    await axios({
      ...options,
      method: "POST",
      url: `/clients/${clientId}/notifications/settings`,
      data: settings,
    });
    return await getNotificationsSettings(clientId, options);
  } catch (error) {
    throw getErrorDetails(error);
  }
}

export async function regenerateSecret(
  clientId: UUID,
  options: any
): Promise<any> {
  try {
    await axios({
      ...options,
      method: "POST",
      url: `/clients/${clientId}/notifications/settings/secret/regenerate`,
    });
    return await getNotificationsSettings(clientId, options);
  } catch (error) {
    throw getErrorDetails(error);
  }
}

export async function getNotifications(
  clientId: UUID,
  options: any
): Promise<any> {
  try {
    const response = await axios({
      ...options,
      method: "GET",
      url: `/client/${clientId}/notifications`,
    });
    const { data = {} } = response;
    return data;
  } catch (error) {
    throw getErrorDetails(error);
  }
}
